import { ENVIRONMENT } from '../../../environment';
import { ContentApi } from '../../../services/content-api';
import { useAuthContext } from '../../../auth/auth-provider';

const { baseUrl } = ENVIRONMENT.publicGateway;

export const useContentApi = () => {
  const { getIdToken } = useAuthContext();
  return new ContentApi({ baseUrl, getAuthToken: getIdToken });
};
